var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrommetSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.1,
    fill: "none",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 80,
    height: 80.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 10,
    y: 10,
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.3326,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    d: "M71.4,13.8 V97H8V15.3c0,0,8.2-4.4,11.4-4.1c3.2,0.3,8.2,2.6,8.2,2.6s4,3.2,8.3,2.7c4.3-0.5,12.7-4,13.6-4.4c0.9-0.3,5.2-2.2,9.7,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D3",
    enableBackground: "new    ",
    d: "M27.6,13.8c0,0-1.8-0.8-4.6-2.2c-2.8-1.4-5.6,0-5.6,0V97h10.2V13.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.9,
    y: 33.1,
    fill: "#9EA2A6",
    width: 12.9,
    height: 63.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D3",
    enableBackground: "new    ",
    d: "M59.9,13.8c0,0-4.3-2.2-6.9-2.6c-2.6-0.4-6,2.6-6,2.6V97h12.9V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 1.5092,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    d: "M8,14.5 c0,0,4.9-1.3,9.1-2.9s9.3,1.2,9.3,1.2s4.1,3.1,9.5,3.7c5.6,0.6,10.2-2.6,10.2-2.6s3.9-2.3,6.9-2.7c3.6-0.4,5.9,2.7,7.2,2.6 c1.3,0,11.9,0,11.9,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.6,
    y: 25.9,
    fill: "#717070",
    enableBackground: "new    ",
    width: 19.3,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.8,
    y: 25.9,
    fill: "#717070",
    enableBackground: "new    ",
    width: 12.6,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 25.9,
    fill: "#717070",
    enableBackground: "new    ",
    width: 18.9,
    height: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EDEDED",
    strokeMiterlimit: 10,
    d: "M11.8,33c0,1.4,1.3,3.5,2.5,3.4c1.9-0.2,3.1-2.9,3.1-6.6 s-1.4-6.6-3.1-6.6c-1.1,0-2.1,1.7-2.3,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EDEDED",
    strokeWidth: 1.0061,
    strokeMiterlimit: 10,
    d: "M41.3,33c0,1.4,1.3,3.5,2.5,3.4 c1.9-0.2,3.1-2.9,3.1-6.6s-1.4-6.6-3.1-6.6c-1.1,0-2.1,1.7-2.3,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EDEDED",
    strokeWidth: 1.0061,
    strokeMiterlimit: 10,
    d: "M33.2,33c0,1.4-1.3,3.5-2.5,3.4 c-1.9-0.2-3.1-2.9-3.1-6.6s1.4-6.6,3.1-6.6c1.1,0,2.1,1.7,2.3,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EDEDED",
    strokeWidth: 1.0061,
    strokeMiterlimit: 10,
    d: "M65.1,33c0,1.4-1.3,3.5-2.5,3.4 c-1.9-0.2-3.1-2.9-3.1-6.6s1.4-6.6,3.1-6.6c1.1,0,2.1,1.7,2.3,2.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrommetSketch);
export default __webpack_public_path__ + "static/media/Grommet_sketch.926839be9bfd72cc5b9742805eb19f97.svg";
export { ForwardRef as ReactComponent };